export enum TableItemType {
  Link = 1,
  Text = 2,
  TextWithPhoto = 3,
  Status = 4,
  Component = 5,
}
